import { useEffect, useRef, useState, useMemo } from 'react'
import FormDrawer from '../../common/form-drawer'
import usePayrollEssentials from 'hooks/usePayrollEssentials';
import { createRemittance, getRemittance, verifyRemittanceBankDetails, updateRemittance } from 'store/entities/payroll/payrollSetup/action';
import Spinner from 'components/__new/common/Spinner';
import { getAllBanks } from 'store/ui/banks/action';
import { toast } from 'react-toastify';
import Maybe from 'components/__new/common/Maybe';
import successGif from "assets/images/icons/success-green.gif";
import { ButtonLoader, Input } from 'components/__new/common/form';
import { validateAccount, validateAccountReset } from 'store/entities/wallet/action';
import { REGEX_VALUES } from 'utils/regexValues';
import validate from "utils/validate";
import ReactSelect from 'react-select';
import { reactSelectStyles } from 'utils/reactSelectStyles';
import useBanks from 'hooks/useBanks';

const formDefault = {
    name: "",
    description: "",
    account_number: "",
    bank_name: "",
    bank_code: "",
}

const CreateRemittanceModal = (props) => {
    const { handleToggleRemittanceForm, userInfo, logger, isRemittanceFormOpen, isEditMode, setIsEditMode, remittance } = props;
    const {dispatch, useSelector, lettersRegex} = usePayrollEssentials()
    const [form, setForm] = useState(formDefault);
    const [bankDetails, setBankDetails] = useState(null);
    const formRef = useRef(null);
    const [isSuccess, setIsSuccess] = useState(false);
    const [remittanceAction, setRemittanceAction] = useState("");

    const {isRemittanceModalOpen, createRemittanceLoading: loading, editRemittanceLoading, verifyRemittanceBankAccountData, createRemittancePayload} = useSelector((state) => state.entities.payrollSetup)
    const { accountValidation, accountValidationLoading } = useSelector((state) => state.entities.wallet);
    const { banks: allBanks, banksLoading } = useBanks(userInfo?.token);
    const [isFormValidated, setIsFormValidated] = useState(true);
    const checkFormValidation = (data = form, appendKey, appendValue) => {
        let params = {...data};
        if (appendKey){ params = {...params, [appendKey]: appendValue}; }
        const errors = validate(params);
        if (errors){
            setIsFormValidated(false);
        }
        else{
            setIsFormValidated(true);
        }
    }

    const isSubmitBtnDisabled = useMemo(() => {
        return !form.name || !form.description || !form?.account_number || form?.account_number?.length !== 10 || !form.bank_code || !bankDetails?.accountName;
    }, [form, bankDetails])   
     
    const banksData = useMemo(() => {
        return allBanks?.sort((a, b) => (a?.bankName || a?.institutionName)?.localeCompare(b?.bankName || b?.institutionName))?.map((singleBank) => ({
            label: singleBank?.bankName || singleBank?.institutionName,
            value: singleBank?.bankCode || singleBank?.institutionCode,
        })) || [];
    }, [allBanks])
    
    const handleCloseRemittanceForm = () => {
        setIsEditMode(false);
        handleToggleRemittanceForm();   
        setBankDetails(null);
        dispatch(validateAccountReset());
    }
    
    const onSubmit = (e) => {
        e.preventDefault();

        if(!lettersRegex.test(form?.name)) {
            toast.error('Remittance name must contain letters')
        } else {
            const bank = allBanks?.find(item => (item?.institutionCode || item?.bankCode) === form.bank_code);
            const payload = {
                ...form,
                bank_name: bank?.bankName || bank?.institutionName,
            }
            if (!isEditMode) {
                logger("Employer-Payroll-setup-remittanceparties-create-success", userInfo);
                // dispatch(createRemittance(payload)).then(() => {
                //     dispatch(getRemittance({ "page": 1, "limit": 10 }));
                //     setBankDetails(null);
                // })
                dispatch(createRemittance(payload));
            } else {
                dispatch(updateRemittance({
                    ...payload,
                    id: remittance?.id,
                    is_default_remittance: remittance?.is_default,
                }));
            }
        }
    }

    const onClose = () => { 
        setForm(formDefault);
        formRef?.current?.reset();
        setBankDetails(null);
        handleCloseRemittanceForm();
    }

    const handleChange = (evt) => {
        const { name, value } = evt.target;
        
                
        if (name === "name" && (!REGEX_VALUES.LETTERS_WITH_NUMBERS_AND_HYPHEN_ONLY.test(value) || value.length > 50)) {
            return;
        }
        
        if (name === "account_number" && value.length > 10) {
            return
        };
        setForm({
            ...form, 
            [name]: value,
        });
    }
    
    useEffect(() => {
        if (isRemittanceFormOpen){
            let data = {...formDefault};
            if (isEditMode){
                data = {
                    ...formDefault,
                    name: remittance?.name || "",
                    description: remittance?.description || "",
                    account_number: remittance?.account_number || "",
                    bank_name: remittance?.bank_name || "",
                    bank_code: remittance?.bank_code || "",
                };
                
                if(remittance?.bank_code?.length > 0 && remittance?.account_number?.length === 10) {
                    setBankDetails(null);
                    const payload = {
                        accountNumber: remittance.account_number,
                        bankCode: remittance?.bank_code
                    }
                    dispatch(validateAccount(userInfo.token, payload));
                }
                setForm(data);
            } else{
                setForm(formDefault);
            }
        }
        // eslint-disable-next-line
    }, [isRemittanceFormOpen]);

    useEffect(() => {
        dispatch(getAllBanks())
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if(form?.bank_code?.length > 0 && form?.account_number?.length === 10) {
            setBankDetails(null);
            const payload = {
                accountNumber: form.account_number,
                bankCode: form?.bank_code
            }
            // dispatch(verifyRemittanceBankDetails(payload));
            dispatch(validateAccount(userInfo.token, payload));
        }
        // eslint-disable-next-line
    }, [form?.bank_code, form?.account_number])

    useEffect(() => {
        if(accountValidation?.responseMsg?.toLowerCase() === "successful") {
            setBankDetails(accountValidation);
        }
        // eslint-disable-next-line
    }, [accountValidation])
    
    useEffect(() => {
        if (createRemittancePayload?.id !== "" && typeof createRemittancePayload?.id === "string"){
            setRemittanceAction(isEditMode ? "edited" : "created");
            handleCloseRemittanceForm();
            setIsSuccess(true);
            dispatch(getRemittance({ "page": 1, "limit": 10 }));
        }
    }, [createRemittancePayload]);

    return (
        <>
           <Maybe condition={isSuccess}>
                <FormDrawer display="center" size="lg" isOpen={isSuccess} setIsOpen={setIsSuccess}>
                    <div className="p-6">
                        <div className="flex justify-center">
                            <div className="h-48 sm:h-56">
                                <img src={successGif} alt="Success" className="h-full object-contain mx-auto" />
                            </div>
                        </div>

                        <div className="mt-4 py-2">
                            <div className="text-center text-[#4A5564] font-normal text-lg">
                                Remittance Party has been {remittanceAction}
                            </div>
                        </div>

                        <div className="py-2 mt-4 flex justify-center gap-6">
                            <button type="button" className="btn btn-lg btn-block rounded-lg whitespace-nowrap text-white bg-ep-primary-600" onClick={() => {
                                setIsSuccess(false)
                            }}>
                                Close
                            </button>
                        </div>
                    </div>
                </FormDrawer>
            </Maybe>
            
            <FormDrawer display="center" size="lg" isOpen={isRemittanceFormOpen} setIsOpen={handleCloseRemittanceForm}>
                <form ref={formRef} onSubmit={onSubmit}>
                    <>
                        <div className="p-7 pb-4">
                            <div className="mb-5">
                                <p className="mb-1 font-semibold">{isEditMode ? "Edit" : "New"} Remittance Party</p>
                            </div>
                            <div className="mb-5">
                                <p className="text-sm mb-2">Name of remittance party <span className="form-input-required">*</span></p>
                                <input minLength={3} maxLength={50} type="text" placeholder='Enter name' required onChange={handleChange} name='name' className="form-input" value={form.name} />
                            </div>

                            <div>
                                <p className="text-sm mb-1">Description <span className="form-input-required">*</span></p>
                                <textarea style={{resize: "none"}} required rows="3" className="form-input-textarea"
                                placeholder='Enter description' onChange={handleChange} name='description' value={form.description} />
                            </div>
                            <hr className="deduct-divider" />

                            <div className="mb-5 pb-2">
                                <p className="text-sm mb-1">Bank name <span className="form-input-required">*</span></p>
                                {/* <select name="bank_code" required onChange={handleChange} className="form-input" value={form.bank_code}>
                                    <option value="">Select bank</option>
                                    {allBanks?.data?.sort((a, b) => (a?.bankName || a?.institutionName)?.localeCompare(b?.bankName || b?.institutionName))?.map((bankData, idx) => (
                                        <option value={bankData?.bankCode || bankData?.institutionCode} key={idx}>
                                            {(bankData?.bankName || bankData?.institutionName)?.toUpperCase()}
                                        </option>
                                    ))}
                                </select> */}
                                <ReactSelect
                                    isDisabled={banksLoading}
                                    isLoading={banksLoading}
                                    isSearchable
                                    name="bank_code"
                                    onChange={(selected) => {
                                        setForm({
                                            ...form, 
                                            bank_code: selected.value,
                                        });
                                    }}
                                    options={banksData}
                                    styles={reactSelectStyles}
                                    placeholder={banksLoading ? "Fetching banks..." : "Select Bank"}
                                    noOptionsMessage={() => "No Banks Found"}
                                />
                            </div>
                            
                            <div className="mb-5 border-b pb-7">
                                <Input 
                                    type="number"
                                    label="Account Number"
                                    required
                                    placeholder="Enter account number"
                                    name="account_number"
                                    value={form.account_number}
                                    onChange={handleChange}
                                    validationName="bankAcctNo"
                                    checkFormValidation={checkFormValidation}
                                />
                            
                                <Maybe condition={accountValidationLoading || bankDetails?.accountName?.length > 0}>
                                    <div className="mt-2.5 text-ep-primary-500 font-medium">
                                        {accountValidationLoading ? "Verifying Details..." : bankDetails?.accountName}
                                    </div>
                                </Maybe>
                            </div>
                        </div>

                        {/* <div className="w-full flex items-center mb-7 pl-7">
                            <button onClick={onClose} type='button' className="btn btn-md btn-transparent-primary mr-4 lg:mr-6">Cancel</button>
                            <button disabled={accountValidationLoading} type="submit" className="btn btn-md btn-ep-primary">Create Remittance</button>
                        </div> */}
                        
                        <div className="w-full flex items-center mb-4 p-7 pb-2 pt-0 justify-end">
                            <button disabled={loading || editRemittanceLoading} onClick={handleCloseRemittanceForm} type='button' className="btn btn-md btn-transparent-primary mr-4 lg:mr-6">
                                Cancel
                            </button>

                            <ButtonLoader loading={loading || editRemittanceLoading} disabled={isSubmitBtnDisabled || accountValidationLoading} type="submit" className="btn btn-md btn-ep-primary">
                                {(loading || editRemittanceLoading) ? "Configuring" : `${isEditMode ? "Edit" : "Create"} Remittance`}
                            </ButtonLoader>
                        </div>
                    </>
                </form>
            </FormDrawer>
        </>
    )
}

export default CreateRemittanceModal